// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════════════════════════
   Mobile home feed sections

   Three blocks that exist only on the phone (MobileFeedSections.js):

     .mf-finds    "Great finds for you" -- a 3-up product grid
     .mf-tiles    "Trending ..." / "Hair & Skincare ..." -- 2x2 tiles with a
                  round arrow in the header

   All three sit on the same --m-gutter-cards edge as the product grid, so
   the whole feed reads as one column rather than a stack of unrelated
   widths.
   ════════════════════════════════════════════════════════════════════════ */

html.m-app .mf-section {
  margin: var(--m-5) var(--m-gutter-cards) 0;
}

html.m-app .mf-head {
  margin-bottom: var(--m-3);
}

html.m-app .mf-head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--m-3);
}

html.m-app .mf-title {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-bold);
  line-height: var(--m-lh-tight);
  letter-spacing: var(--m-track-title);
  margin: 0;
}

html.m-app .mf-sub {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  margin: 2px 0 0;
}

/* "View all →" reuses .cat-row-viewall so it is literally the same control
   as the one on Top Sales rather than a lookalike. Padding cancelled by an
   equal negative margin gives it a 44px tap target without adding height to
   the header row. */
html.m-app .mf-viewall {
  flex: 0 0 auto;
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-semibold);
  color: var(--color-secondary-text);
  padding: 11px 8px;
  margin: -11px -8px;
  white-space: nowrap;
}

/* ── "Great finds for you": 3 up ────────────────────────────────────────
   Three columns rather than the storefront's two. These are browse-and-
   discover cards, not the considered comparison the main grid is for, so
   the image can be smaller and more of them can be on screen at once --
   which is exactly the trade the reference makes. */
html.m-app .mf-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--m-3) var(--m-2);
}

html.m-app .mf-card {
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
  min-width: 0;
  color: inherit;
  text-decoration: none;
}

html.m-app .mf-card:active {
  opacity: 0.7;
}

html.m-app .mf-card-img-wrap {
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: var(--m-r-sm);
  overflow: hidden;
  background: var(--m-surface-sunken);
}

html.m-app .mf-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Rating sits over the image, bottom-left, as on the product cards. The
   green here is the sanctioned rating token, not a new colour. */
html.m-app .mf-card-rating {
  position: absolute;
  left: var(--m-1);
  bottom: var(--m-1);
}

html.m-app .mf-card-name {
  font-size: var(--m-fs-caption);
  line-height: var(--m-lh-snug);
  color: var(--color-text-secondary);
  /* One line: at a third of the screen a wrapping name makes the row ragged
     and pushes the price out of alignment across the three columns. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

html.m-app .mf-card-price-row {
  display: flex;
  align-items: baseline;
  gap: var(--m-1);
  min-width: 0;
}

html.m-app .mf-card-price {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-bold);
  font-variant-numeric: tabular-nums;
}

html.m-app .mf-card-was {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
  text-decoration: line-through;
  font-variant-numeric: tabular-nums;
}

/* ── Tile sections: 2x2 on a tinted panel ───────────────────────────────
   The reference sets these blocks on a soft coloured panel so they read as
   a curated group rather than more of the feed. Two tones, both mixed from
   the brand hues rather than introducing new ones. */
html.m-app .mf-tiles {
  padding: var(--m-4);
  border-radius: var(--m-r-lg);
}

html.m-app .mf-tiles-a {
  background: color-mix(in srgb, var(--color-secondary) 8%, var(--color-brand-white));
}

html.m-app .mf-tiles-b {
  background: color-mix(in srgb, var(--color-primary) 7%, var(--color-brand-white));
}

html.m-app[data-theme="dark"] .mf-tiles-a {
  background: color-mix(in srgb, var(--color-secondary) 14%, transparent);
}

html.m-app[data-theme="dark"] .mf-tiles-b {
  background: color-mix(in srgb, var(--color-primary) 12%, transparent);
}

html.m-app .mf-tile-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--m-3);
}

html.m-app .mf-tile {
  display: flex;
  flex-direction: column;
  gap: var(--m-1);
  min-width: 0;
  color: inherit;
  text-decoration: none;
}

html.m-app .mf-tile:active { opacity: 0.7; }

html.m-app .mf-tile-img-wrap {
  display: block;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: var(--m-r-sm);
  overflow: hidden;
  /* White behind the photo even in dark mode: these are cut-out product
     shots on white, and a dark plate behind them shows every edge. */
  background: var(--color-brand-white);
}

html.m-app .mf-tile-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

html.m-app .mf-tile-label {
  font-size: var(--m-fs-caption);
  color: var(--color-text-secondary);
  line-height: var(--m-lh-snug);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

html.m-app .mf-tile-claim {
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-bold);
  line-height: var(--m-lh-snug);
  color: var(--color-text-primary);
}

/* ── Infinite scroll ────────────────────────────────────────────────────
   Replaces the Prev/Next pager on mobile. The element below is both the
   IntersectionObserver sentinel and the status line, so there is exactly one
   thing at the bottom of the list rather than a hidden tripwire plus a
   separate spinner. */
html.m-app .shop-infinite {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: var(--m-5) var(--m-gutter-cards);
  font-size: var(--m-fs-secondary);
  color: var(--color-text-secondary);
  text-align: center;
}

html.m-app .shop-infinite-loading {
  display: inline-flex;
  align-items: center;
  gap: var(--m-2);
}

html.m-app .shop-infinite-spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--m-hairline-strong);
  border-top-color: var(--color-secondary);
  animation: mf-spin 700ms linear infinite;
}

@keyframes mf-spin { to { transform: rotate(360deg); } }

@media (prefers-reduced-motion: reduce) {
  html.m-app .shop-infinite-spinner { animation: none; }
}

/* The end of the list is a statement, not an absence. */
html.m-app .shop-infinite-end {
  font-size: var(--m-fs-caption);
  color: var(--color-text-muted);
}

/* ── "More products for you" header ─────────────────────────────────────
   On the phone this grid follows the curated feed blocks, so its header is
   a continuation rather than the top of a catalogue. The sort <select> that
   sat beside it is hidden: it is a desktop control (a native picker opening
   over six options to reorder an infinite list), and with the pager gone
   there is no longer a natural place to land after reordering.

   NOTE: this removes sorting from the phone entirely. If it should come
   back, the mobile-native form is a chip row or a filter sheet, not this
   dropdown -- say the word and I will build that instead. */
html.m-app .shop-controls {
  display: none;
}

html.m-app .shop-header {
  display: block;
  padding: 0 var(--m-gutter-cards);
  margin-bottom: var(--m-3);
}

html.m-app .shop-header h2 {
  font-size: var(--m-fs-section);
  font-weight: var(--m-fw-bold);
  letter-spacing: var(--m-track-title);
  margin: 0;
}

/* ── Sort chips ─────────────────────────────────────────────────────────
   The replacement for the sort <select> hidden above. A rail of chips: every
   option visible, one tap to apply, and the current choice readable without
   opening anything -- which a native picker cannot do.

   Blue for the active chip because selection is blue's role in this palette,
   and navy on blue is 5.6:1, so the label stays legible on the fill where
   white would fail. */
html.m-app .shop-sort-chips {
  display: flex;
  gap: var(--m-2);
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  /* Sits on the same edge as the cards it reorders, and scrolls past it --
     a rail that stops short of the screen edge reads as clipped. */
  padding: 0 var(--m-gutter) var(--m-3);
  margin: 0;
  scroll-padding-inline: var(--m-gutter);
}

html.m-app .shop-sort-chips::-webkit-scrollbar { display: none; }

html.m-app .shop-sort-chip {
  flex: 0 0 auto;
  min-height: 34px;
  padding: 0 var(--m-3);
  border: 1px solid var(--color-border);
  border-radius: var(--m-r-pill);
  background: var(--m-surface-card);
  color: var(--color-text-secondary);
  font-size: var(--m-fs-secondary);
  font-weight: var(--m-fw-medium);
  white-space: nowrap;
  cursor: pointer;
}

html.m-app .shop-sort-chip.is-active {
  background: var(--color-secondary);
  border-color: var(--color-secondary);
  color: var(--color-text-on-secondary);
  font-weight: var(--m-fw-semibold);
}

html.m-app .shop-sort-chip:active { opacity: 0.7; }

html.m-app .shop-sort-chip:focus-visible {
  outline: 2px solid var(--color-secondary);
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/mobile/feed.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;6EAY6E;;AAE7E;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B;EAC9B,oCAAoC;EACpC,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;;oBAGoB;AACpB;EACE,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;EAClC,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;oDAIoD;AACpD;EACE,aAAa;EACb,gDAAgD;EAChD,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;iEACiE;AACjE;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;EAClC;sEACoE;EACpE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;;qDAGqD;AACrD;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,iFAAiF;AACnF;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;AACvE;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,qBAAqB;AACvB;;AAEA,6BAA6B,YAAY,EAAE;;AAE3C;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB;qEACmE;EACnE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;;;;sBAIsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD;EACE,oCAAoC,eAAe,EAAE;AACvD;;AAEA,wDAAwD;AACxD;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;;;;;;;;;4DAS4D;AAC5D;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,SAAS;AACX;;AAEA;;;;;;;sBAOsB;AACtB;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC;mEACiE;EACjE,qCAAqC;EACrC,SAAS;EACT,sCAAsC;AACxC;;AAEA,iDAAiD,aAAa,EAAE;;AAEhE;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;EAClC,gCAAgC;EAChC,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA,oCAAoC,YAAY,EAAE;;AAElD;EACE,yCAAyC;EACzC,mBAAmB;AACrB","sourcesContent":["/* ════════════════════════════════════════════════════════════════════════\n   Mobile home feed sections\n\n   Three blocks that exist only on the phone (MobileFeedSections.js):\n\n     .mf-finds    \"Great finds for you\" -- a 3-up product grid\n     .mf-tiles    \"Trending ...\" / \"Hair & Skincare ...\" -- 2x2 tiles with a\n                  round arrow in the header\n\n   All three sit on the same --m-gutter-cards edge as the product grid, so\n   the whole feed reads as one column rather than a stack of unrelated\n   widths.\n   ════════════════════════════════════════════════════════════════════════ */\n\nhtml.m-app .mf-section {\n  margin: var(--m-5) var(--m-gutter-cards) 0;\n}\n\nhtml.m-app .mf-head {\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .mf-head-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--m-3);\n}\n\nhtml.m-app .mf-title {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-bold);\n  line-height: var(--m-lh-tight);\n  letter-spacing: var(--m-track-title);\n  margin: 0;\n}\n\nhtml.m-app .mf-sub {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  margin: 2px 0 0;\n}\n\n/* \"View all →\" reuses .cat-row-viewall so it is literally the same control\n   as the one on Top Sales rather than a lookalike. Padding cancelled by an\n   equal negative margin gives it a 44px tap target without adding height to\n   the header row. */\nhtml.m-app .mf-viewall {\n  flex: 0 0 auto;\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-semibold);\n  color: var(--color-secondary-text);\n  padding: 11px 8px;\n  margin: -11px -8px;\n  white-space: nowrap;\n}\n\n/* ── \"Great finds for you\": 3 up ────────────────────────────────────────\n   Three columns rather than the storefront's two. These are browse-and-\n   discover cards, not the considered comparison the main grid is for, so\n   the image can be smaller and more of them can be on screen at once --\n   which is exactly the trade the reference makes. */\nhtml.m-app .mf-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--m-3) var(--m-2);\n}\n\nhtml.m-app .mf-card {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n  min-width: 0;\n  color: inherit;\n  text-decoration: none;\n}\n\nhtml.m-app .mf-card:active {\n  opacity: 0.7;\n}\n\nhtml.m-app .mf-card-img-wrap {\n  position: relative;\n  display: block;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  background: var(--m-surface-sunken);\n}\n\nhtml.m-app .mf-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Rating sits over the image, bottom-left, as on the product cards. The\n   green here is the sanctioned rating token, not a new colour. */\nhtml.m-app .mf-card-rating {\n  position: absolute;\n  left: var(--m-1);\n  bottom: var(--m-1);\n}\n\nhtml.m-app .mf-card-name {\n  font-size: var(--m-fs-caption);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-secondary);\n  /* One line: at a third of the screen a wrapping name makes the row ragged\n     and pushes the price out of alignment across the three columns. */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nhtml.m-app .mf-card-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: var(--m-1);\n  min-width: 0;\n}\n\nhtml.m-app .mf-card-price {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-bold);\n  font-variant-numeric: tabular-nums;\n}\n\nhtml.m-app .mf-card-was {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n  text-decoration: line-through;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ── Tile sections: 2x2 on a tinted panel ───────────────────────────────\n   The reference sets these blocks on a soft coloured panel so they read as\n   a curated group rather than more of the feed. Two tones, both mixed from\n   the brand hues rather than introducing new ones. */\nhtml.m-app .mf-tiles {\n  padding: var(--m-4);\n  border-radius: var(--m-r-lg);\n}\n\nhtml.m-app .mf-tiles-a {\n  background: color-mix(in srgb, var(--color-secondary) 8%, var(--color-brand-white));\n}\n\nhtml.m-app .mf-tiles-b {\n  background: color-mix(in srgb, var(--color-primary) 7%, var(--color-brand-white));\n}\n\nhtml.m-app[data-theme=\"dark\"] .mf-tiles-a {\n  background: color-mix(in srgb, var(--color-secondary) 14%, transparent);\n}\n\nhtml.m-app[data-theme=\"dark\"] .mf-tiles-b {\n  background: color-mix(in srgb, var(--color-primary) 12%, transparent);\n}\n\nhtml.m-app .mf-tile-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--m-3);\n}\n\nhtml.m-app .mf-tile {\n  display: flex;\n  flex-direction: column;\n  gap: var(--m-1);\n  min-width: 0;\n  color: inherit;\n  text-decoration: none;\n}\n\nhtml.m-app .mf-tile:active { opacity: 0.7; }\n\nhtml.m-app .mf-tile-img-wrap {\n  display: block;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: var(--m-r-sm);\n  overflow: hidden;\n  /* White behind the photo even in dark mode: these are cut-out product\n     shots on white, and a dark plate behind them shows every edge. */\n  background: var(--color-brand-white);\n}\n\nhtml.m-app .mf-tile-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\nhtml.m-app .mf-tile-label {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-secondary);\n  line-height: var(--m-lh-snug);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\nhtml.m-app .mf-tile-claim {\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-bold);\n  line-height: var(--m-lh-snug);\n  color: var(--color-text-primary);\n}\n\n/* ── Infinite scroll ────────────────────────────────────────────────────\n   Replaces the Prev/Next pager on mobile. The element below is both the\n   IntersectionObserver sentinel and the status line, so there is exactly one\n   thing at the bottom of the list rather than a hidden tripwire plus a\n   separate spinner. */\nhtml.m-app .shop-infinite {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 72px;\n  padding: var(--m-5) var(--m-gutter-cards);\n  font-size: var(--m-fs-secondary);\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\nhtml.m-app .shop-infinite-loading {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--m-2);\n}\n\nhtml.m-app .shop-infinite-spinner {\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  border: 2px solid var(--m-hairline-strong);\n  border-top-color: var(--color-secondary);\n  animation: mf-spin 700ms linear infinite;\n}\n\n@keyframes mf-spin { to { transform: rotate(360deg); } }\n\n@media (prefers-reduced-motion: reduce) {\n  html.m-app .shop-infinite-spinner { animation: none; }\n}\n\n/* The end of the list is a statement, not an absence. */\nhtml.m-app .shop-infinite-end {\n  font-size: var(--m-fs-caption);\n  color: var(--color-text-muted);\n}\n\n/* ── \"More products for you\" header ─────────────────────────────────────\n   On the phone this grid follows the curated feed blocks, so its header is\n   a continuation rather than the top of a catalogue. The sort <select> that\n   sat beside it is hidden: it is a desktop control (a native picker opening\n   over six options to reorder an infinite list), and with the pager gone\n   there is no longer a natural place to land after reordering.\n\n   NOTE: this removes sorting from the phone entirely. If it should come\n   back, the mobile-native form is a chip row or a filter sheet, not this\n   dropdown -- say the word and I will build that instead. */\nhtml.m-app .shop-controls {\n  display: none;\n}\n\nhtml.m-app .shop-header {\n  display: block;\n  padding: 0 var(--m-gutter-cards);\n  margin-bottom: var(--m-3);\n}\n\nhtml.m-app .shop-header h2 {\n  font-size: var(--m-fs-section);\n  font-weight: var(--m-fw-bold);\n  letter-spacing: var(--m-track-title);\n  margin: 0;\n}\n\n/* ── Sort chips ─────────────────────────────────────────────────────────\n   The replacement for the sort <select> hidden above. A rail of chips: every\n   option visible, one tap to apply, and the current choice readable without\n   opening anything -- which a native picker cannot do.\n\n   Blue for the active chip because selection is blue's role in this palette,\n   and navy on blue is 5.6:1, so the label stays legible on the fill where\n   white would fail. */\nhtml.m-app .shop-sort-chips {\n  display: flex;\n  gap: var(--m-2);\n  overflow-x: auto;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n  /* Sits on the same edge as the cards it reorders, and scrolls past it --\n     a rail that stops short of the screen edge reads as clipped. */\n  padding: 0 var(--m-gutter) var(--m-3);\n  margin: 0;\n  scroll-padding-inline: var(--m-gutter);\n}\n\nhtml.m-app .shop-sort-chips::-webkit-scrollbar { display: none; }\n\nhtml.m-app .shop-sort-chip {\n  flex: 0 0 auto;\n  min-height: 34px;\n  padding: 0 var(--m-3);\n  border: 1px solid var(--color-border);\n  border-radius: var(--m-r-pill);\n  background: var(--m-surface-card);\n  color: var(--color-text-secondary);\n  font-size: var(--m-fs-secondary);\n  font-weight: var(--m-fw-medium);\n  white-space: nowrap;\n  cursor: pointer;\n}\n\nhtml.m-app .shop-sort-chip.is-active {\n  background: var(--color-secondary);\n  border-color: var(--color-secondary);\n  color: var(--color-text-on-secondary);\n  font-weight: var(--m-fw-semibold);\n}\n\nhtml.m-app .shop-sort-chip:active { opacity: 0.7; }\n\nhtml.m-app .shop-sort-chip:focus-visible {\n  outline: 2px solid var(--color-secondary);\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
